import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'



const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/api/v1/admin/:todo',
    name: 'todo',
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/masters/list',
    component: () => import(/* webpackChunkName: "master_list_view" */ '../views/MasterListView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/masters/ifsc_master',
    component: () => import(/* webpackChunkName: "ifsc_master" */ '../views/IfscMaster.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/masters/account_type_master',
    component: () => import(/* webpackChunkName: "account_master" */ '../views/AccountMaster.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/masters/frequency_master',
    component: () => import(/* webpackChunkName: "frequency_master" */ '../views/FrequencyMaster.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/masters/source_master',
    component: () => import(/* webpackChunkName: "source_master" */ '../views/SourceMaster.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/masters/organisation_master',
    component: () => import(/* webpackChunkName: "organisation_master" */ '../views/OrganizationMaster.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/masters/utility_master',
    component: () => import(/* webpackChunkName: "utility_master" */ '../views/UtilityMaster.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/checker',
    component: () => import(/* webpackChunkName: "checker_view" */ '../views/CheckerView.vue'),
    meta: { requiresAuth: true },
  }, {
    path: '/api/v1/admin/upload/reverse_file',
    component: () => import(/* webpackChunkName: "checker_view" */ '../views/UploadReverseFile.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/maker',
    component: () => import(/* webpackChunkName: "maker_view" */ '../views/MakerView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/masters/category_master',
    component: () => import(/* webpackChunkName: "category_master" */ '../views/CategoryMaster.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/masters/branch_master',
    component: () => import(/* webpackChunkName: "branch_master" */ '../views/BranchMaster.vue'),
    meta: { requiresAuth: true },
  }, {
    path: '/api/v1/admin/masters/status_master',
    component: () => import(/* webpackChunkName: "status_master" */ '../views/StatusMaster.vue'),
    meta: { requiresAuth: true },
  }, {
    path: '/api/v1/admin/users_list',
    component: () => import(/* webpackChunkName: "users_list" */ '../views/UserList.vue'),
    meta: { requiresAuth: true },
  }, {
    path: '/api/v1/admin/user_management',
    component: () => import(/* webpackChunkName: "users_list" */ '../views/UserManagement.vue'),
    meta: { requiresAuth: true },
  }, {
    path: '/api/v1/admin/m3s/schedular/list',
    component: () => import(/* webpackChunkName: "schedular" */ '../views/SchedulerView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/masters/roles/true',
    component: () => import(/* webpackChunkName: "roles" */ '../views/RolesMaster.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/masters/bounced_master',
    component: () => import(/* webpackChunkName: "bounced_master" */ '../views/BouncedMaster.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/ifscmaster/upload',
    component: () => import(/* webpackChunkName: "upload_ifsc_master" */ '../views/UploadIfscMaster.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/branchmaster/upload',
    component: () => import(/* webpackChunkName: "upload_branch_master" */ '../views/UploadBranchMaster.vue'),
    meta: { requiresAuth: true },
  }, {
    path: '/api/v1/operation/upload_sourcedata/checker',
    component: () => import(/* webpackChunkName: "schedular" */ '../views/UploadVerificationView.vue'),
    meta: { requiresAuth: true },
  }, {
    path: '/api/v1/operation/txn/details',
    component: () => import(/* webpackChunkName: "schedular" */ '../views/TransactionDetailsView.vue'),
    meta: { requiresAuth: true },
  }, {
    path: '/api/v1/operation/upload_sourcedata/upload',
    component: () => import(/* webpackChunkName: "upload_writer_data" */ '../views/UploadSourceData.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/upload_sourcedata/upload',
    component: () => import(/* webpackChunkName: "upload_source_data" */ '../views/UploadSourceData.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/upload_writerdata/upload',
    component: () => import(/* webpackChunkName: "upload_writer_data" */ '../views/UploadWriters.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/upload_od_data/upload',
    component: () => import(/* webpackChunkName: "upload_Od_data" */ '../views/UploadOD.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/upload_transaction/upload',
    component: () => import(/* webpackChunkName: "upload_transaction_data" */ '../views/UploadTransaction.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/upload_parentchild_data/upload',
    component: () => import(/* webpackChunkName: "upload_parentchild_data" */ '../views/UploadParentChild.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/holdunhold',
    component: () => import(/* webpackChunkName: "upload_holdUnhold_data" */ '../views/HoldUnholdMandate.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/admin/accountclose',
    component: () => import(/* webpackChunkName: "upload_accountclose_data" */ '../views/AccountClose.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/upload_mandate/upload',
    name: 'pendingMandate',
    component: () => import(/* webpackChunkName: "pending_mandate" */ '../views/PendingMandate.vue'),
    meta: { requiresAuth: true },
  }, {
    path: '/api/v1/operation/mandate/mandate_validation/:loanAccountNumber/:status',
    name: 'mandateValidation',
    component: () => import(/* webpackChunkName: "mandate_maintenance" */ '../views/MandateValidationView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/swap',
    component: () => import(/* webpackChunkName: "pending_mandate" */ '../views/SwapView.vue'),
    meta: { requiresAuth: true },
  }, {
    path: '/api/v1/operation/mandate/mandatecancellation',
    component: () => import(/* webpackChunkName: "pending_mandate" */ '../views/MandateCancellationView.vue'),
    meta: { requiresAuth: true },
  },

  {
    path: '/api/v1/operation/upload_mandate/upload/loan_preview/:loanAccountNumber/:edit',
    name: 'loanPreview',
    component: () => import(/* webpackChunkName: "loan_preview" */ '../views/LoanPreview.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/upload_mandate/upload/upload_image',
    name: 'uploadImage',
    component: () => import(/* webpackChunkName: "uploadImage" */ '../views/UploadMandate.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/upload_mandate/upload/bulk_upload',
    name: 'bulkUpload',
    component: () => import(/* webpackChunkName: "bulk_upload" */ '../views/BulkMandateUpload.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/mandate/record_validation',
    name: 'mandateList',
    component: () => import(/* webpackChunkName: "record_validation" */ '../views/MandateValidationList.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/mandate_wo_source/mandates',
    component: () => import(/* webpackChunkName: "mandate_wo_source" */ '../views/Mandate_wo_Source.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/upload_mandate/rejected_mandate/true',
    name: 'rejectedMandate',
    component: () => import(/* webpackChunkName: "rejected_mandate" */ '../views/RejectedMandate.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/report/downloadreports',
    component: () => import(/* webpackChunkName: "download_reports" */ '../views/DownloadReports.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/report/mandate',
    component: () => import(/* webpackChunkName: "branch_wise_report" */ '../views/BranchReport.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/report/mismatch',
    component: () => import(/* webpackChunkName: "mismatch_report" */ '../views/MismatchReport.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/server_log/logs',
    component: () => import(/* webpackChunkName: "server_logs" */ '../views/ServerLogs.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/report/lan_wise_view_report',
    component: () => import(/* webpackChunkName: "LANwiseView" */ '../views/LANwiseViewReport.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/mandate/pdf',
    component: () => import(/* webpackChunkName: "mandate_pdf" */ '../views/MandatePDF.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/mandate/R7report',
    component: () => import(/* webpackChunkName: "R7_report" */ '../views/R7report.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/report/transaction',
    name: 'transactionReport',
    component: () => import(/* webpackChunkName: "TransactionReport" */ '../views/TransactionReport.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/report/lan_wise_transaction_report',
    name: 'lanwisetransactionReport',
    component: () => import(/* webpackChunkName: "TransactionReport" */ '../views/LANWiseTransactionReport.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/update_loan_hierarchy/select_parent/true',
    component: () => import(/* webpackChunkName: "loanHierarchy" */ '../views/ChildLoanAssignment.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/operation/report/module_list_api',
    component: () => import(/* webpackChunkName: "loanHierarchy" */ '../views/CustomDownload.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/api/v1/DownloadManagement',
    component: () => import(/* webpackChunkName: "loanHierarchy" */ '../views/DownloadMangement.vue'),
    meta: { requiresAuth: true },

  },{
      path:`/api/v1/operation/report/download_large_reports`,
      component: () => import(/* webpackChunkName: "loanHierarchy" */ '../views/DownloadLargeReport.vue'),
      meta: { requiresAuth: true },
  },{
    path:`/api/v1/admin/sftp`,
    component: () => import(/* webpackChunkName: "loanHierarchy" */ '../views/SFTPManagement.vue'),
    meta: { requiresAuth: true },
},
  {
    path: `/api/v1/operation/report/download_stagging_records`,
    component: () => import(/* webpackChunkName: "stageRecords" */ '../views/DownloadStageRecords.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: `/api/v1/admin/transaction_reprocessing`,
    component: () => import(/* webpackChunkName: "stageRecords" */ '../views/TransactionReprocessing.vue'),
    meta: { requiresAuth: true },
  }
]



const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

const w = window as any;
let timerStart: any;

router.beforeEach((to, from, next) => {

  const isAuthenticated = !!localStorage.getItem('session-token'); // Check for session token

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // This route requires authentication
    if (!isAuthenticated) {
      // No session detected, redirect to login
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      // Session detected, proceed to route
      next();
    }
  } else {
    // Route does not require authentication
    next();
  }

  timerStart = Date.now()

});

router.afterEach((to, from) => {

  const time_load = ((Date.now() - timerStart) / 1000);
  w['$']("#page_load").html("Page Load Time: " + time_load + " ms")
  // Perform actions after the route change, like hiding a loading indicator
  // For example: store.commit('SET_LOADING', false);
});

export default router
